import { ESignInfoSection } from "eSign/components/DocumentDetails/EsignInfoSection";
import moment from "moment";
import ReadonlyProductsPanelSegment from "Products/ReadonlyProductsPanelSegment";
import React from "react";
import ReadonlyLinkedShowsPanelSegment from "../../document/linkshow/ReadonlyLinkedShowsPanelSegment";
import TwoColumnLayout from "../../layout/TwoColumnLayout";
import ESignActivityPanel from "../components/activity/ESignActivityPanel";
import ESignOptionsPanel from "../components/optionspanel/ESignOptionsPanel";
import ViewDocumentButton from "../components/ViewDocumentButton";
import ReadonlyFilesPanelSegment from "../panelsegment/ReadonlyFilesPanelSegment";
import ViewerPanelSegment from "../panelsegment/ViewerPanelSegment";
import { SenderPanel } from "eSign/panelsegment/SenderPanel";
import { DetailSectionTemplate } from "components/MainSectionTemplate/DetailSectionTemplate";
import { SignerPanel } from "eSign/panelsegment/SignerPanel";
import NotesPanel from "note/list/app";
import { DocumentReminderApp } from "DocumentReminder/AppForDocuments";
import { DocumentTypeWithoutUnknown } from "utilities/documentUtils";

interface Props {
  viewModel: server.viewmodel.ESignDetailFrontModel
}

const PendingPanel = (props: Props): JSX.Element => {
  const { viewModel } = props;

  const documentType = viewModel.details.documentType as DocumentTypeWithoutUnknown;
  const sendMoment = moment(viewModel.details.sendDate);
  const dueMoment = sendMoment.add(viewModel.details.dueInDays, "days");
  const localMoment = moment(site.localNow);
  const overDue = localMoment >= dueMoment;

  return <TwoColumnLayout>
    <TwoColumnLayout.LeftColumn>
      <DetailSectionTemplate
        isInPageEditable={false}
        onValueChanged={() => { }}
        sections={[
          {
            type: "custom",
            key: "infoSection",
            render: () => <ESignInfoSection
              documentType={documentType}
              esignDocument={viewModel.details}
              stepOptions={{
                draft: { disabled: true },
                review: { disabled: true },
                pending: { disabled: false },
                completed: { disabled: true }
              }}
              overDue={overDue}
              activeStep="pending"
              brands={viewModel.brands}
            />
          },
          SenderPanel({
            esignDocument: viewModel.details,
            sender: viewModel.sender,
            progress: viewModel.senderProgress,
          }),
          SignerPanel({
            esignDocument: viewModel.details,
            signer: viewModel.signer,
            progress: viewModel.signerProgress
          }),
          {
            type: "custom",
            key: "viewDocumentButton",
            render: () => <ViewDocumentButton
              documentNumber={viewModel.details.documentNumber}
              label={RESX.ESign.ViewDocument}
              version={viewModel.details.version}
              documentId={viewModel.details.documentId}
            />
          },
          {
            type: "custom",
            key: "viewPanel",
            render: () => <ViewerPanelSegment
              initialViewers={viewModel.viewers}
              document={viewModel.details}
            />
          },
          {
            type: "custom",
            key: "filesThatNeedSigningPanel",
            render: () => <ReadonlyFilesPanelSegment
              label={RESX.ESign.PdfsThatNeedToBeSigned}
              files={viewModel.filesThatNeedToBeSigned}
            />
          },
          {
            key: "otherFilesPanel",
            type: "custom",
            render: () => <ReadonlyFilesPanelSegment
              label={RESX.ESign.OtherFiles}
              files={viewModel.otherFiles}
            />
          },
          {
            type: "custom",
            key: "productsPanel",
            render: () => <ReadonlyProductsPanelSegment
              productsPanel={viewModel.productsPanel}
            />
          },
          {
            type: "custom",
            key: "linkedShowsPanel",
            render: () => <ReadonlyLinkedShowsPanelSegment
              documentType={viewModel.details.documentType}
              linkedShowsPanel={viewModel.linkedShowsPanel}
            />
          }, {
            key: "notesPanel",
            type: "custom",
            render: () => <NotesPanel
              mainArea={documentType}
              useSectionPanel
              config={viewModel.linkedNotePanelConfig}
            />
          }
        ]}
      />
    </TwoColumnLayout.LeftColumn>
    <TwoColumnLayout.RightColumn>
      <ESignOptionsPanel
        optionsPanel={viewModel.optionsPanel}
        listUrl={viewModel.listUrl}
        documentDetails={viewModel.details}
        copyUrl={viewModel.copyUrl}
      />
      <DocumentReminderApp
        document={viewModel.details}
        initialReminders={viewModel.reminders}
      />
      <ESignActivityPanel
        documentId={viewModel.details.documentId}
        config={viewModel.activityPanel}
      />
    </TwoColumnLayout.RightColumn>
  </TwoColumnLayout >
}

export default PendingPanel;
